import React from "react";

// Animations
import { motion } from "framer-motion";
import { pageAnimation, titleAnim } from "../animation";

// Styled components
import styled from "styled-components";

// Scroll top
import ScrollTop from "../components/ScrollTop";

const ContactUs = () => {
  return (
    <ContactStyle
      variants={pageAnimation}
      initial="hidden"
      animate="show"
      exit="exit"
      style={{
        background: "#fff",
      }}
    >
      <Title>
        <Hide>
          <motion.h2 variants={titleAnim}>Contact Me</motion.h2>
        </Hide>
      </Title>
      <div>
        <Hide>
          <Social variants={titleAnim}>
            <Circle />
            <h2>Github: <a href="https://github.com/SleepyAryan">Sleepy</a></h2>
          </Social>
        </Hide>
        <Hide>
          <Social variants={titleAnim}>
            <Circle />
            <h2>Linkedin: <a href="https://www.linkedin.com/in/aryan-dash-a42a7518b/">Aryan Dash</a></h2>
          </Social>
        </Hide>
        <Hide>
          <Social variants={titleAnim}>
            <Circle />
            <h2>LeetCode: <a href="https://leetcode.com/AryanNoobie/">Aryan</a></h2>
          </Social>
        </Hide>
      </div>
      <ScrollTop />
    </ContactStyle>
  );
};

const ContactStyle = styled(motion.div)`
  padding: 5rem 10rem;
  color: #353535;
  min-height: 90vh;
  @media screen and (max-width: 1500px) {
    padding: 2rem;
    font-size: 1rem;
  }
`;

const Title = styled.div`
  margin-bottom: 4rem;
  color: black;
  @media screen and (max-width: 1500px) {
    margin-top: 5rem;
  }
`;

const Hide = styled.div`
  overflow: hidden;
`;

const Circle = styled.div`
  border-radius: 50%;
  width: 1rem;
  height: 1rem;
  background: #353535;
`;

const Social = styled(motion.div)`
  display: flex;
  align-items: center;
  h2 {
    margin: 1rem;
    font-size: 2rem;
  }
`;

export default ContactUs;
